import React, { useMemo } from "react";
import PropTypes from "prop-types";
import { useFormikContext } from "formik";

import Divider from "ui/Divider";
import Switch from "ui/Switch";
import { FormGroupTitle, FormSwitchField } from "ui/Form";

const FeaturesContent = ({ featureFields }) => {
  const { values, setFieldValue } = useFormikContext();
  const featureFieldsLength = useMemo(
    () => Object.keys(featureFields).length,
    [featureFields],
  );

  const fieldNameGenerator = (id) => `features[${id}]`;

  const renderFeatures = ([groupName, features], index) => {
    const isLast = featureFieldsLength === index + 1;
    return (
      <div key={`feature-group-${groupName}`}>
        {renderGroup(groupName, features)}
        {Object.entries(features).map(renderFeature)}
        {!isLast && <Divider />}
      </div>
    );
  };

  const isFeaturesChecked = (featureIds) =>
    featureIds.every((id) => values.features[id]);

  const setFeaturesChecked = (featureIds, value) => {
    featureIds.forEach((id) => setFieldValue(fieldNameGenerator(id), value));
  };

  const renderGroup = (groupName, features) => {
    const featureIds = Object.keys(features);
    const checked = isFeaturesChecked(featureIds);
    const onChange = (_, value) => setFeaturesChecked(featureIds, value);
    return (
      <FormGroupTitle
        title={
          <div>
            {groupName}
            <Switch checked={checked} onChange={onChange} />
          </div>
        }
      />
    );
  };

  const renderFeature = ([id, name]) => (
    <FormSwitchField
      key={`limit-${id}-value`}
      name={fieldNameGenerator(id)}
      label={name}
      padding="0"
    />
  );

  return Object.entries(featureFields).map(renderFeatures);
};

FeaturesContent.propTypes = {
  featureFields: PropTypes.object.isRequired,
};

export default FeaturesContent;
